<template>
  <div class="card-modal">
    <slot name="body" />
  </div>
</template>

<script lang="ts" setup></script>

<style>
  .card-modal {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px;
    height: 120px;
    box-shadow:
      10px 4px 8px 2px rgba(0, 0, 0, 0.2),
      10px 6px 20px 7px rgba(0, 0, 0, 0.19);
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    background: white;
    z-index: 99999;
    width: 100%;
  }

  .unlock-btn {
    display: flex;
    width: 100%;
    justify-content: center;
    flex-direction: column;
    align-items: center;
  }
</style>
